g<template>
  <div class="certificateorder">
    <h1 id="formTitle">Disaster recovery replacement certificates request</h1>
    <ValidationObserver ref="form" v-slot="{ errors, valid }">
      <!-- using an anchor to scroll to since jQuery doesn't work the first time with a hidden element -->
      <a name="id-a-errors" id="id-a-errors"></a>
      <ValidationErrors
        :class="{ hidden: !showErrors || valid }"
        :errors="errors"
      />
      <form @submit.prevent="submitForm" id="submitForm" novalidate>
        <span class="h3">There are currently no active disaster events.</span>

        <!--        <span class="h3">Location of disaster area</span>-->
        <SelectDisasterArea :areas="areas" v-model="form.theDeclaredLocation" />
          <span v-if="form.theDeclaredLocation != ''" class="h3"
          >Local government area</span
        >
        <SelectLGA
          :areas="areas"
          v-model="form.declaredLocalArea"
          v-if="form.theDeclaredLocation != ''"
        />
        <fieldset>
          <div class="status info">
            <abbr
              class="required consent-abbr"
              id="label-info-consent"
              title="(required)"
              >*
            </abbr>
            <ValidationProvider rules="required:#label-info-consent">
              <input
                id="info-consent"
                v-model="form.infoConsent"
                value="true"
                type="checkbox"
                name="Info Consent"
                vid="info-consent"
              />
            </ValidationProvider>
            <label style="display:none" for="info-consent">Consent</label>
            <span>
              By using the following online service and providing an email
              address and contact number, I consent to the use of that email
              address and contact number for the Registry of Births, Deaths and
              Marriages (RBDM) to provide me with email or SMS correspondence
              that relate to this request. I understand that it is my
              responsibility to ensure that I have nominated a secure email
              address for RBDM to send the correspondence to. I acknowledge that
              it is my responsibility to ensure the security of that information
              when I receive it.
            </span>
          </div>
        </fieldset>
        <div v-if="form.infoConsent && form.declaredLocalArea">
          <ol class="questions">
            <ContactDetails v-model="form" />
            <li class="section" id="section2">
              <fieldset>
                <legend><span class="h3">Order details</span></legend>
                <div class="status warn">
                  <h2>Supporting documents must be submitted</h2>
                  <p>
                    We cannot process your application form until we receive
                    your documents. If submitting your application form by post
                    or in person your supporting documents must be attached to
                    your printed and signed application form.
                  </p>
                </div>
                <ol class="questions">
                  <li>
                    <fieldset>
                      <legend>
                        <span class="label"
                          >How will you submit your
                          <a
                            target="_blank"
                            href="https://www.qld.gov.au/family/help-centre/proof-of-identity-and-supporting-documents"
                            >supporting documentation?</a
                          ></span
                        >
                        <abbr
                          class="required"
                          id="label-submit-where"
                          title="(required)"
                          >*</abbr
                        >
                      </legend>
                      <br />
                      <ul class="choices">
                        <p>Online by:</p>
                        <li>
                          <ValidationProvider
                            rules="required:#label-submit-where"
                          >
                            <input
                              v-model="form.submitWhere"
                              id="submit-online"
                              value="online"
                              name="Submit Where"
                              type="radio"
                            />
                          </ValidationProvider>

                          <label for="submit-online"
                            >submitting this form online and attaching certified
                            copies of supporting documents</label
                          >
                        </li>
                        <p>In person at:</p>
                        <li>
                          <input
                            v-model="form.submitWhere"
                            id="submit-at-local-court"
                            value="localCourt"
                            name="Submit Where"
                            type="radio"
                          />
                          <label for="submit-at-local-court"
                            >your local
                            <a
                              href="https://www.qld.gov.au/family/help-centre/courthouse-and-qgap-locations"
                              target="_blank"
                              >Queensland Magistrates Court or Queensland
                              Government Agent Program (QGAP)</a
                            >
                            office (except the Brisbane Magistrates Court)
                            with <strong>original</strong> supporting
                            documents</label
                          >
                        </li>
                        <p>Or by post:</p>
                        <li>
                          <input
                            v-model="form.submitWhere"
                            id="submit-by-post"
                            value="post"
                            name="Submit Where"
                            type="radio"
                          />
                          <label for="submit-by-post"
                            >to RBDM with <strong>certified copies</strong> of
                            supporting documents (address will be provided at
                            end)</label
                          >
                        </li>
                      </ul>
                    </fieldset>
                  </li>
                </ol>
              </fieldset>
            </li>
            <li>
              <fieldset>
                <legend>
                  <span class="label"
                    >What type of certificate(s) do you need to replace for
                    yourself?</span
                  >
                  <abbr
                    class="required"
                    id="label-certificateOrderProduct"
                    title="(required)"
                    >*</abbr
                  >
                </legend>
                <ul class="choices">
                  <li>
                    <ValidationProvider
                      rules="required:#label-certificateOrderProduct"
                    >
                      <input
                        id="birthCertificate"
                        v-model="form.certificateOrderProduct"
                        value="birthCertificate"
                        name="Order Product"
                        type="checkbox"
                        @change="check($event)"
                        :disabled="noneForSelf"
                      />
                    </ValidationProvider>

                    <label for="birthCertificate">Birth certificate—with sex shown</label>
                  </li>
                  <li>
                    <input
                      id="marriageCertificate"
                      v-model="form.certificateOrderProduct"
                      value="marriageCertificate"
                      name="Order Product"
                      type="checkbox"
                      @change="check($event)"
                      :disabled="noneForSelf"
                    />
                    <label for="marriageCertificate"
                      >Marriage or civil partnership certificate</label
                    >
                  </li>
                  <li>
                    <input
                      id="changeOfNameCertificate"
                      v-model="form.certificateOrderProduct"
                      value="changeOfNameCertificate"
                      name="Order Product"
                      type="checkbox"
                      @change="check($event)"
                      :disabled="noneForSelf"
                    />
                    <label for="changeOfNameCertificate"
                      >Change of name certificate</label
                    >
                  </li>
                  <li>
                    <input
                      id="noneForSelf"
                      v-model="form.certificateOrderProduct"
                      value="child1BirthCertificate"
                      type="checkbox"
                      name="Order Product"
                      @change="check($event)"
                    />
                    <label for="noneForSelf">None</label>
                  </li>
                </ul>
              </fieldset>
            </li>
            <div class="status info">
              We can only replace a certificate if you have had one before.
            </div>
            <SelfBirthCert
              v-if="form.certificateOrderProduct.includes('birthCertificate')"
              v-model="form"
              today="today"
            />
            <SelfCONCert
              v-if="
                form.certificateOrderProduct.includes('changeOfNameCertificate')
              "
              v-model="form"
              today="today"
            />
            <SelfMarriageCert
              v-if="
                form.certificateOrderProduct.includes('marriageCertificate')
              "
              v-model="form"
              today="today"
            />
            <ChildBirthCerts
              v-model="form"
              today="today"
              :noneForSelf="noneForSelf"
            />

            <UploadDocumentation
              v-if="form.submitWhere == 'online'"
              v-model="uploads"
              max="6"
            />
            <li>
              <fieldset>
                <legend>
                  <span class="label">I declare that</span>
                  <abbr
                    class="required"
                    title="(required)"
                    id="label-declaration"
                    >*</abbr
                  >
                </legend>
                <ol class="questions">
                  <li>
                    <Declaration index="1" v-model="form.declaration1">
                      <label for="declaration1" style="display: inline"
                        >the details I have provided in the form are true and
                        correct.</label
                      >
                    </Declaration>
                  </li>
                  <li>
                    <Declaration index="2" v-model="form.declaration2">
                      <label for="declaration2"
                        >I have had the certificate(s) I am asking for before
                        but they have been destroyed in a declared natural
                        disaster.</label
                      >
                    </Declaration>
                  </li>
                </ol>
              </fieldset>
            </li>
            <li>
              <fieldset>
                <legend>
                  <span class="label">I understand that</span>
                  <abbr class="required" title="(required)">*</abbr>
                </legend>
                <ol class="questions">
                  <li>
                    <Declaration index="3" v-model="form.declaration3">
                      <label for="declaration3"
                        >giving false and misleading information is a serious
                        offence.</label
                      >
                    </Declaration>
                  </li>
                  <li>
                    <Declaration index="4" v-model="form.declaration4">
                      <label for="declaration4"
                        >by providing these details I consent to the use of the
                        details to help RBDM process my application so I can be
                        sent the requested certificate(s).</label
                      >
                    </Declaration>
                  </li>
                </ol>
              </fieldset>
            </li>
            <li id="inProgress">
              <p v-if="inProgress">Submitting your enquiry...</p>
              <p v-else></p>
            </li>
            <li>
              <fieldset>
                <ul class="actions">
                  <li>
                    <strong
                      ><button
                        :disabled="uploads.uploading > 0 || inProgress"
                        id="submitButton"
                      >
                        Submit your application
                      </button></strong
                    >
                  </li>
                </ul>
              </fieldset>
            </li>
          </ol>
          <hr />
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import sppapi from "@/sppapi.js";
import SelectLGA from "./forms/SelectLGA.vue";
import SelectDisasterArea from "./forms/SelectDisasterArea.vue";
import ContactDetails from "./forms/ContactDetails.vue";
import ChildBirthCerts from "./forms/ChildBirthCerts.vue";
import SelfBirthCert from "./forms/SelfBirthCert.vue";
import SelfCONCert from "./forms/SelfCONCert.vue";
import SelfMarriageCert from "./forms/SelfMarriageCert.vue";
import UploadDocumentation from "./forms/UploadDocumentation.vue";
import ValidationErrors from "../ValidationErrors.vue";
import Declaration from "./forms/components/Declaration.vue";
import $ from "jquery";

export default {
  name: "TheDisasterRecoveryForm",
  data: function() {
    return {
      showErrors: false,
      processId: "disasterRecoveryCertOrd",
      contactPhone: "",
      contactEmail: "",
      form: {
        theDeclaredLocation: "",
        declaredLocalArea: "",
        applicantFirstName: "",
        applicantMiddleName: "",
        applicantFamilyName: "",
        applicantPreferredContactMobile: "",
        applicantPreferredContactEmail: "",
        applicantDisasterAddressLine1: "",
        applicantDisasterAddressLine2: "",
        applicantDisasterAddressLine3: "",
        applicantDisasterTownCitySuburb: "",
        applicantDisasterState: "",
        applicantDisasterPostcode: "",
        isAddressSame: "",
        applicantHomeAddressLine1: "",
        applicantHomeAddressLine2: "",
        applicantHomeAddressLine3: "",
        applicantHomeTownCitySuburb: "",
        applicantHomeState: "",
        applicantHomePostcode: "",
        submitWhere: "",
        certificateOrderProduct: [],
        productsOrdered: "",
        birthTownCitySelf: "",
        birthStateSelf: "",
        dateOfBirthSelf: "",
        selfGivenName: "",
        selfMiddleNames: "",
        selfFamilyName: "",
        selfMothersGivenName: "",
        selfMothersMiddleNames: "",
        selfMothersFamilyName: "",
        selfParentsGivenName: "",
        selfParentsMiddleNames: "",
        selfParentsFamilyName: "",
        newGivenName: "",
        newMiddleNames: "",
        newFamilyName: "",
        birthGivenName: "",
        birthMiddleNames: "",
        birthFamilyName: "",
        dateOfNameChangeSelf: "",
        marriageTownCity: "",
        marriageState: "",
        dateOfMarriage: "",
        p1GivenName: "",
        p1MiddleNames: "",
        p1FamilyName: "",
        p2GivenName: "",
        p2MiddleNames: "",
        p2FamilyName: "",
        childrenCertsReplace: "",
        birthTownCityChild1: "",
        birthStateChild1: "",
        dateOfBirthChild1: "",
        child1GivenName: "",
        child1MiddleNames: "",
        child1FamilyName: "",
        child1Sex: "",
        child1SexOther: "",
        addAnotherChildToMyApplication1: "",
        birthTownCityChild2: "",
        birthStateChild2: "",
        dateOfBirthChild2: "",
        child2GivenName: "",
        child2MiddleNames: "",
        child2FamilyName: "",
        child2Sex: "",
        child2SexOther: "",
        addAnotherChildToMyApplication2: "",
        birthTownCityChild3: "",
        birthStateChild3: "",
        dateOfBirthChild3: "",
        child3GivenName: "",
        child3MiddleNames: "",
        child3FamilyName: "",
        child3Sex: "",
        child3SexOther: "",
        contactMe: "",
        declaration1: false,
        declaration2: false,
        declaration3: false,
        declaration4: false,
        productOrdered1: "",
        productOrdered2: "",
        productOrdered3: "",
        productOrdered4: "",
        productOrdered5: "",
        productOrdered6: "",
      },
      noneForSelf: false,
      uploads: {
        uploadIds: [],
        uploading: 0,
        acceptedTypes: ".jpg, .tiff, .png, .jpeg, .pdf",
        supportingFiles: 1,
      },
      inProgress: false,
      areas: [
        //    {
        //   id: "NorthQueenslandMonsoon24December2025",
        //   name: "Queensland Monsoon Trough, Cyclone Koji, Cyclone Narelle and Severe Weather, commencing 24 December 2025",
        //   selected: false,
        //   locations: [
        //       "Winston Shire Council",
        //       "Cassowary Coast Regional Council",
        //       "Flinders Shire Council",
        //       "Richmond Shire Council",
        //       "Isaac Regional Council",
        //       "Mackay Regional Council",
        //       "McKinlay Shire Council",
        //       "Carpentaria Shire Council",
        //       "Livingstone Shire Council",
        //       "Whitsunday Regional Council",
        //       "Etheridge Shire Council",
        //       "Charters Towers Regional Council",
        //       "Banana Shire Council",
        //       "Bundaberg Regional Council",
        //       "Central Highlands Regional Council",
        //       "Douglas Shire Council",
        //       "Doomadgee Aboriginal Shire Council",
        //       "Gladstone Regional Council",
        //       "Western Downs Regional Council",
        //       "Barcaldine Regional Council",
        //       "North Burnett Regional Council",
        //       "Fraser Coast Regional Council",
        //       "Napranum Aboriginal Shire Council",
        //       "Cook Shire Council",
        //       "Weipa Town Authority",
        //       "Longreach Shire Council",
        //       "Lockhart River Aboriginal Shire Council",
        //       "Cloncurry Shire Council",
        //       "Barcoo Shire Council"
        //   ]
        // },
        ],
    };
  },
  methods: {
    check(event) {
      if (event.srcElement.id === "noneForSelf") {
        this.noneForSelf = event.target.checked;

        // disable all the other options and remove from the list of products
        if (this.noneForSelf) {
          $('#birthCertificate').prop("checked", false);
          this.removeBirthCertDetails();
          $('#marriageCertificate').prop("checked", false);
          this.removeMarriageDetails();
          $('#changeOfNameCertificate').prop("checked", false);
          this.removeCONDetails();
          this.form.certificateOrderProduct = ['child1BirthCertificate'];
        }
        if (
          this.form.childrenCertsReplace === "false" ||
          !this.form.childrenCertsReplace
        ) {
          this.form.childrenCertsReplace = "true";
        } else {
          this.form.childrenCertsReplace = "false";
          this.form.certificateOrderProduct = this.form.certificateOrderProduct
            .filter((product) =>  !product.includes("child"))
          this.removeChildDetails();
        }
      }
      // reset values when the boxes are unchecked
      else if (
        event.srcElement.id === "birthCertificate" &&
        !event.target.checked
      ) {
        this.removeBirthCertDetails();
      } else if (
        event.srcElement.id === "marriageCertificate" &&
        !event.target.checked
      ) {
        this.removeMarriageDetails();
      } else if (
        event.srcElement.id === "changeOfNameCertificate" &&
        !event.target.checked
      ) {
        this.removeCONDetails();
      }
    },
    resetChildDetails(childNumber) {
      const birthTownCityChild = "birthTownCityChild" + childNumber;
      const birthStateCityChild = "birthStateCityChild" + childNumber;
      const dateOfBirthChild = "dateOfBirthChild" + childNumber;
      const childGivenName = "child" + childNumber + "GivenName";
      const childMiddleNames = "child" + childNumber + "MiddleNames";
      const childFamilyName = "child" + childNumber + "FamilyName";
      const addAnotherChildToMyApplication =
        "addAnotherChildToMyApplication" + childNumber;

      this.form[birthTownCityChild] = "";
      this.form[birthStateCityChild] = "";
      this.form[dateOfBirthChild] = "";
      this.form[childGivenName] = "";
      this.form[childMiddleNames] = "";
      this.form[childFamilyName] = "";
      this.form[addAnotherChildToMyApplication] = "";
    },
    removeChildDetails(childNumber = null) {
      if (!childNumber) {
        for (const x of Array(3).keys()) {
          this.resetChildDetails(x);
        }
      } else {
        this.resetChildDetails(childNumber);
      }
    },
    removeMarriageDetails() {
      this.form.marriageTownCity = "";
      this.form.marriageState = "";
      this.form.dateOfMarriage = "";
      this.form.p1GivenName = "";
      this.form.p1MiddleNames = "";
      this.form.p1FamilyName = "";
      this.form.p2GivenName = "";
      this.form.p2MiddleNames = "";
      this.form.p2FamilyName = "";
    },
    removeBirthCertDetails() {
      this.form.birthTownCitySelf = "";
      this.form.birthStateSelf = "";
      this.form.dateOfBirthSelf = "";
      this.form.selfGivenName = "";
      this.form.selfMiddleNames = "";
      this.form.selfFamilyName = "";
    },
    removeCONDetails() {
      this.form.newGivenName = "";
      this.form.newMiddleNames = "";
      this.form.newFamilyName = "";

      this.form.birthGivenName = "";
      this.form.birthMiddleNames = "";
      this.form.birthFamilyName = "";

      this.form.dateOfBirthSelf = "";
      this.form.birthTownCitySelf = "";
      this.form.birthStateSelf = "";
      this.form.dateOfNameChangeSelf = "";
    },
    submitForm: function(event) {
      event.preventDefault();
      // todo: refactor so each component only gets passed in the data it needs 
      // to avoid collisions ie the state marriage form
      // or just add vuex

      this.form.productsOrdered = this.form.certificateOrderProduct.join(";");
      // set an individual field for each product so they are more easily readable in portal
      this.form.certificateOrderProduct.forEach((value, index) => {
        this.form[`productOrdered${index + 1}`] = (value.charAt(0).toUpperCase() + value.slice(1))
          .match(/[A-Z][a-z]+|[0-9]+/g).join(" ");
      });

      this.contactPhone = this.form.applicantPreferredContactMobile;
      this.contactEmail = this.form.applicantPreferredContactEmail;

      if (
        this.form.submitWhere == "online" &&
        this.uploads.uploadIds.length == 0
      ) {
        $("#upload-warning").css("display", "block");
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $("#upload-warning").offset().top,
          },
          600
        );
        return;
      }

      this.$refs.form.validate().then((success) => {
        if (!success) {
          this.showErrors = true;
          const el = document.getElementById("id-a-errors");
          el.scrollIntoView({ behavior: "smooth" });
          return;
        } else {
          sppapi.startProcessAndCompleteTask(this);
        }
      });
    },
  },
  components: {
    SelectLGA,
    ContactDetails,
    ChildBirthCerts,
    SelfBirthCert,
    SelfCONCert,
    SelfMarriageCert,
    UploadDocumentation,
    SelectDisasterArea,
    ValidationErrors,
    Declaration,
  },
};
</script>

<style scoped lang="scss">
.consent-abbr {
  display: inline;
}

#inProgress {
  height: 1em;
}

#uploading {
  height: 1em;
}

.hidden {
  display: none;
}

.applicantPreferredContactEmail {
  width: 100%;
}
</style>
